import Vue from 'vue'
import {mapActions} from 'vuex'
import * as config from './config.js'
import { CNPJ_MASK } from './masks'

Vue.mixin({
  computed: {
    cnpjMask () {
      return CNPJ_MASK
    }
  },
  methods: {
    graphQL (data) {
      return this.$http.post(config.apiDomain + 'graphql', data)
    },
    linkRegistration () {
      let domain = config.displayURL.replace('//', '//' + this.company.display_name + '.')
      return domain + 'registration/' + this.client.id
    },
    handleLogout () {
      this.unsetUser()
      window.parent.postMessage({logout: true}, '*')
    },
    setTagInterval () {
      return setInterval(() => {
        window.parent.postMessage({
          iframeHeight: this.$el.clientHeight
        }, '*')
      }, 300)
    },
    imageUrl (path, resize = false) {
      let extension = path.substring(path.lastIndexOf('.') + 1)
      let fileName = path.substring(0, path.lastIndexOf('.'))
      let template = 'original'
      if (resize) {
        fileName += '-resize(' + resize + ')'
        template = 'resize'
      }
      let url = fileName + '.' + extension
      return config.cdnURL + 'image/' + template + '/' + url
    },
    textStyle () {
      return 'color:' + this.company.company_settings.display.text_color + ';'
    },
    buttonStyle () {
      return 'color:' + this.company.company_settings.display.button_text_color + ';' +
      'background:' + this.company.company_settings.display.button_color + ';' +
      'background-image: none;'
    },
    isMobile (clientWidth) {
      let fullWidth = clientWidth
      return (fullWidth < 992)
    },
    phoneNumber: str => {
      if (!str || str === '') return ''
      str = str.replace('_', '')
      if (str.length === 13) {
        let num = str.charAt(8)
        str = str.replace(num + '-', '-' + num)
      }
      return str
    },
    capitalizeFirstLetter: str => str.charAt(0).toUpperCase() + str.slice(1),
    time: (value, full = true) => {
      if (!value || value === '') return '-'
      if (full) {
        return window.moment(value, 'DD/MM/YY à\\s H\\hm').calendar(null, {
          sameDay: '[Hoje] [às] H:mm',
          nextDay: '[Amanhã] [às] H:mm',
          nextWeek: 'DD/MM/YY [às] H:mm',
          lastDay: '[Ontem] [às] H:mm',
          lastWeek: 'DD/MM/YY [às] H:mm',
          sameElse: 'DD/MM/YY [às] H:mm'
        })
      } else {
        return window.moment(value, 'DD/MM/YYYY').calendar(null, {
          sameDay: '[Hoje]',
          nextDay: '[Amanhã]',
          nextWeek: 'DD/MM/YY',
          lastDay: '[Ontem]',
          lastWeek: 'DD/MM/YY',
          sameElse: 'DD/MM/YY'
        })
      }
    },
    money: (value) => {
      if (isNaN(value) || parseFloat(value) < 1) return '- -'
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2
      }).format(value)
    },
    rentType: (value) => {
      let types = [null, 'Diária', 'Semanal', 'Quinzenal', 'Mensal']
      return types[value]
    },
    periodName: (value) => {
      let types = [null, 'Manhã', 'Tarde']
      return types[value]
    },
    rentPeriod (type) {
      return [null, 'dia', 'semana', 'quinzena', 'mês'][type]
    },
    rentPeriods (periods, type) {
      if (periods === 1) {
        return [null, 'dia', 'semana', 'quinzena', 'mês'][type]
      } else if (periods > 1) {
        return [null, 'dias', 'semanas', 'quinzenas', 'mêses'][type]
      }
      return ''
    },
    paymentMethod: (value) => {
      let text = ''
      switch (value) {
        case 'cash':
          text = 'Dinheiro'
          break
        case 'boleto':
          text = 'Boleto'
          break
        case 'credit_card':
          text = 'Cartão de Crédito'
          break
        default:
          text = '- -'
      }
      return text
    },
    slugify (text) {
      text = text.toString().toLowerCase().trim()
      const sets = [
        {to: 'a', from: '[ÀÁÂÃÄÅÆĀĂĄẠẢẤẦẨẪẬẮẰẲẴẶ]'},
        {to: 'c', from: '[ÇĆĈČ]'},
        {to: 'd', from: '[ÐĎĐÞ]'},
        {to: 'e', from: '[ÈÉÊËĒĔĖĘĚẸẺẼẾỀỂỄỆ]'},
        {to: 'g', from: '[ĜĞĢǴ]'},
        {to: 'h', from: '[ĤḦ]'},
        {to: 'i', from: '[ÌÍÎÏĨĪĮİỈỊ]'},
        {to: 'j', from: '[Ĵ]'},
        {to: 'ij', from: '[Ĳ]'},
        {to: 'k', from: '[Ķ]'},
        {to: 'l', from: '[ĹĻĽŁ]'},
        {to: 'm', from: '[Ḿ]'},
        {to: 'n', from: '[ÑŃŅŇ]'},
        {to: 'o', from: '[ÒÓÔÕÖØŌŎŐỌỎỐỒỔỖỘỚỜỞỠỢǪǬƠ]'},
        {to: 'oe', from: '[Œ]'},
        {to: 'p', from: '[ṕ]'},
        {to: 'r', from: '[ŔŖŘ]'},
        {to: 's', from: '[ßŚŜŞŠ]'},
        {to: 't', from: '[ŢŤ]'},
        {to: 'u', from: '[ÙÚÛÜŨŪŬŮŰŲỤỦỨỪỬỮỰƯ]'},
        {to: 'w', from: '[ẂŴẀẄ]'},
        {to: 'x', from: '[ẍ]'},
        {to: 'y', from: '[ÝŶŸỲỴỶỸ]'},
        {to: 'z', from: '[ŹŻŽ]'},
        {to: '-', from: '[·/_,:;\']'}
      ]

      sets.forEach(set => {
        text = text.replace(new RegExp(set.from, 'gi'), set.to)
      })

      return text
      .replace(/\s+/g, '-')    // Replace spaces with -
      .replace(/[^\w-]+/g, '') // Remove all non-word chars
      .replace(/--+/g, '-')    // Replace multiple - with single -
      .replace(/^-+/, '')      // Trim - from start of text
      .replace(/-+$/, '')      // Trim - from end of text
    },
    getTypeClientPjFiles (type) {
      let description = ''
      switch (type) {
        case 'partner_document':
          description = 'Documento do Sócio'
          break
        case 'cnpj_card':
          description = 'Cartão CNPJ'
          break
        case 'proof_of_state_registration':
          description = 'Comprovante Inscrição Estadual'
          break
        default:
          description = 'Comprovante de Enderenço'
          break
      }
      return description
    },
    ...mapActions(['unsetUser'])
  }
})



// WEBPACK FOOTER //
// ./src/mixin.js